var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import qs from "qs";
import { DealListSort, DealStatus } from "@irati/types";
import { showFilterTags } from "@irati/deals/helpers/deals/showFilterTags";
import authentication from "@irati/auth";
import History from "@irati/utils/history";
import Loading from "@irati/ui/src/Loading";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import categoriesService from "@irati/deals/services/dealCategory";
import dealsService from "@irati/deals/services/dealsGraph";
import locationFilterTagsService from "@irati/deals/services/locationFilterTags";
import perksGoFilterTagsService from "@irati/deals/services/perksGoFilterTags";
import DealListComponent, { getDealList } from "@irati/deals/apollo/query/DealList";
import { hangPromise } from "@irati/utils/promise";
import { IconTypes } from "@irati/ui/src/Icon";
import { FiltersWrapper } from "../../components/Categories/styled";
import { StyledFilterBy, StyledSortBy, DisplayCount } from "./styled";
import locationTags from "../../utils/deals/locationTags";
import { getSelectedCategory, getSelectedTags } from "../../utils/deals/dealList";
import Categories from "../../components/Categories";
import SectionHeader from "../../components/SectionHeader";
import { SORT_OPTIONS } from "../../constants/dealSort";
import DEAL_PAGES from "../../constants/dealPage";
import DealList from "../../components/DealList";
import ShowMoreOrThatsAll from "../../components/DealList/ShowMoreOrThatsAll";
import BadCategoryOrTag, { ALL_CATEGORY } from "../../components/DealList/BadCategoryOrTag";
var getTagsUuids = function (tags) {
    return tags.map(function (tag) { return tag.uuid; });
};
var INITIAL_VARIABLES = { statuses: [DealStatus.On, DealStatus.Unavailable], limit: 9, sort: DealListSort.Date };
var Deals = /** @class */ (function (_super) {
    __extends(Deals, _super);
    function Deals() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            variables: INITIAL_VARIABLES,
            categories: [],
            selectedCategory: undefined,
            selectedTags: [],
            selectedPerksGoTags: [],
            selectedLocationTags: locationTags.list(),
            loadFilterOptions: hangPromise(),
            loadPerksGoFilterOptions: hangPromise(),
            perksGoFilterOptions: [],
            filterOptions: []
        };
        _this.handleCategoryOrTagChange = function (category, tags) {
            var pathname = "/categories";
            if (category.url) {
                pathname += "/" + category.url;
            }
            var search = "";
            if (tags && tags.length > 0) {
                var formatted = tags.map(function (tag) { return tag.url; }).join("+");
                search = "tags=" + formatted;
            }
            History.push({ pathname: pathname, search: search || null }, _this.context);
        };
        _this.handleSort = function (_a) {
            var sort = _a.value;
            _this.setState(function (prevState) { return ({
                variables: __assign(__assign({}, prevState.variables), { sort: sort })
            }); });
        };
        _this.getFilterOptions = function () {
            var localStorage = locationTags.list();
            var loadFilterOptions = locationFilterTagsService.get().then(function (tags) {
                var options = tags.map(function (tag) {
                    var uuid = tag.uuid, name = tag.name, isNational = tag.isNational;
                    return {
                        uuid: uuid,
                        name: name,
                        value: name
                            .toLowerCase()
                            .split(" ")
                            .join("-"),
                        isChecked: localStorage.length ? localStorage.includes(tag.uuid) : true,
                        isNational: isNational
                    };
                });
                locationTags.removeOldFromLocalStorage(tags);
                return options.sort(function (a, b) { return a.name.localeCompare(b.name); });
            });
            _this.setState({
                loadFilterOptions: loadFilterOptions
            });
            return loadFilterOptions;
        };
        _this.getPerksGoFilterOptions = function () {
            var loadPerksGoFilterOptions = perksGoFilterTagsService.list().then(function (tags) {
                var options = tags.map(function (tag) {
                    var uuid = tag.uuid, name = tag.name;
                    return {
                        uuid: uuid,
                        name: _this.props.formatMessage({ id: "perks.categories.filterBy.perksGo.filter." + name }),
                        value: name
                            .toLowerCase()
                            .split(" ")
                            .join("-"),
                        isChecked: true
                    };
                });
                return options.sort(function (a, b) { return a.name.localeCompare(b.name); });
            });
            _this.setState({
                loadPerksGoFilterOptions: loadPerksGoFilterOptions
            });
            return loadPerksGoFilterOptions;
        };
        _this.handleSelectAllFilters = function (event) {
            var filterOptions = _this.state.filterOptions;
            if (!filterOptions)
                return;
            filterOptions.forEach(function (option) {
                option.isChecked = event.target.checked;
            });
            _this.setState({ filterOptions: filterOptions });
        };
        _this.handleSelectFilter = function (event) {
            var filterOptions = _this.state.filterOptions;
            if (!filterOptions)
                return;
            filterOptions.forEach(function (option) {
                if (option.value === event.target.id) {
                    option.isChecked = event.target.checked;
                }
            });
            _this.setState({ filterOptions: filterOptions });
        };
        _this.handleResetFilters = function () {
            var filterOptions = _this.state.filterOptions;
            if (!filterOptions)
                return;
            var dealLocationTags = locationTags.list();
            filterOptions.forEach(function (option) {
                option.isChecked = dealLocationTags.length ? dealLocationTags.includes(option.uuid) : true;
            });
            _this.setState({ filterOptions: filterOptions });
        };
        _this.handleApplyFilters = function () { return __awaiter(_this, void 0, void 0, function () {
            var filterOptions, selectedLocationTags, allFiltersSelected;
            return __generator(this, function (_a) {
                filterOptions = this.state.filterOptions;
                if (!filterOptions)
                    return [2 /*return*/];
                // force national to always be selected
                filterOptions.forEach(function (option) {
                    if (option.isNational) {
                        option.isChecked = true;
                    }
                });
                selectedLocationTags = filterOptions.filter(function (option) { return option.isChecked; }).map(function (option) { return option.uuid; });
                allFiltersSelected = selectedLocationTags.length === filterOptions.length;
                if (allFiltersSelected) {
                    selectedLocationTags = [];
                }
                locationTags.set(selectedLocationTags);
                this.setState({ selectedLocationTags: selectedLocationTags });
                return [2 /*return*/];
            });
        }); };
        _this.handleSelectAllPerksGoFilters = function (event) {
            var perksGoFilterOptions = _this.state.perksGoFilterOptions;
            if (!perksGoFilterOptions)
                return;
            perksGoFilterOptions.forEach(function (option) {
                option.isChecked = event.target.checked;
            });
            _this.setState({ perksGoFilterOptions: perksGoFilterOptions });
        };
        _this.handleSelectPerksGoFilter = function (event) {
            var perksGoFilterOptions = _this.state.perksGoFilterOptions;
            if (!perksGoFilterOptions)
                return;
            perksGoFilterOptions.forEach(function (option) {
                if (option.value === event.target.id) {
                    option.isChecked = event.target.checked;
                }
            });
            _this.setState({ perksGoFilterOptions: perksGoFilterOptions });
        };
        _this.handleResetPerksGoFilters = function () {
            var _a = _this.state, perksGoFilterOptions = _a.perksGoFilterOptions, selectedPerksGoTags = _a.selectedPerksGoTags;
            if (!perksGoFilterOptions)
                return;
            perksGoFilterOptions.forEach(function (option) {
                option.isChecked = selectedPerksGoTags.length > 0 ? selectedPerksGoTags.includes(option.uuid) : true;
            });
            _this.setState({ perksGoFilterOptions: perksGoFilterOptions });
        };
        _this.handleApplyPerksGoFilters = function () {
            var perksGoFilterOptions = _this.state.perksGoFilterOptions;
            if (!perksGoFilterOptions)
                return;
            var selectedPerksGoTags = perksGoFilterOptions.filter(function (option) { return option.isChecked; }).map(function (option) { return option.uuid; });
            var allFiltersSelected = selectedPerksGoTags.length === perksGoFilterOptions.length;
            if (allFiltersSelected) {
                selectedPerksGoTags = [];
            }
            _this.setState({ selectedPerksGoTags: selectedPerksGoTags });
        };
        _this.handleNewPage = function (isVisible, apollo) {
            if (isVisible) {
                var _a = getDealList(apollo), results = _a.results, count = _a.count;
                var resultsLength = (results === null || results === void 0 ? void 0 : results.length) || 0;
                if (resultsLength && resultsLength !== count) {
                    // has more
                    return apollo.nextPage(__assign(__assign({}, INITIAL_VARIABLES), { offset: resultsLength }));
                }
            }
        };
        return _this;
    }
    Deals.getDerivedStateFromProps = function (props, state) {
        var _a;
        var category = props.match.params.category;
        var query = qs.parse(location.href.split("?")[1]);
        var selectedCategory = getSelectedCategory(state.categories, category);
        var selectedTags = getSelectedTags(selectedCategory, (_a = query === null || query === void 0 ? void 0 : query.tags) === null || _a === void 0 ? void 0 : _a.split(" "));
        var variables = state.variables, selectedPerksGoTags = state.selectedPerksGoTags;
        variables.tags = __spreadArrays(getTagsUuids(selectedTags), selectedPerksGoTags);
        variables.locationTags = state.selectedLocationTags;
        if (variables.tags.length === 0) {
            delete variables.tags;
        }
        if (variables.locationTags.length === 0) {
            delete variables.locationTags;
        }
        if (variables.tags) {
            variables.hideEB = false;
            variables.hidePerksGo = false;
        }
        else {
            // hide EBdeals and PerksGo just when on the "All Perks" tab
            variables.hideEB = true;
            variables.hidePerksGo = true;
        }
        return {
            selectedCategory: selectedCategory,
            selectedTags: selectedTags,
            variables: variables
        };
    };
    Deals.prototype.componentDidMount = function () {
        var _this = this;
        var load = Promise.all([
            dealsService.list(INITIAL_VARIABLES),
            categoriesService.listForCurrentPackage()
        ]).then(function (_a) {
            var rootDeals = _a[0], dealCategories = _a[1];
            var allCount = rootDeals.count;
            _this.setState({
                categories: [__assign(__assign({}, ALL_CATEGORY), { dealCount: allCount })].concat(dealCategories)
            });
        });
        this.setState({ load: load });
        Promise.all([this.getFilterOptions(), this.getPerksGoFilterOptions()]).then(function (_a) {
            var filterOptions = _a[0], perksGoFilterOptions = _a[1];
            _this.setState({ filterOptions: filterOptions, perksGoFilterOptions: perksGoFilterOptions });
        });
    };
    Deals.prototype.render = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        var _a = this.state, load = _a.load, selectedCategory = _a.selectedCategory, selectedTags = _a.selectedTags, categories = _a.categories, variables = _a.variables, loadFilterOptions = _a.loadFilterOptions, filterOptions = _a.filterOptions, loadPerksGoFilterOptions = _a.loadPerksGoFilterOptions, perksGoFilterOptions = _a.perksGoFilterOptions, selectedLocationTags = _a.selectedLocationTags, selectedPerksGoTags = _a.selectedPerksGoTags;
        var showPerksGoFilter = authentication.apps("perks.perksGo") && showFilterTags(perksGoFilterOptions);
        return (React.createElement(Row, null,
            React.createElement(Col, { md: 12 },
                React.createElement(Loading, { load: load },
                    React.createElement(SectionHeader, { id: id("categories-header", this.props), className: "text-center" },
                        React.createElement(FormattedMessage, { id: "perks.containers.deals.browseBy" })),
                    React.createElement(Categories, { categories: categories, selectedCategory: selectedCategory, selectedTags: selectedTags, onChange: this.handleCategoryOrTagChange }),
                    React.createElement(FiltersWrapper, { direction: "column", justifyContent: "space-between", marginBottom: 2 },
                        showPerksGoFilter && (React.createElement(StyledFilterBy, { id: id("filter", this.props), loadFilterOptions: loadPerksGoFilterOptions, filterOptions: perksGoFilterOptions, savedFilterOptionsExist: !!selectedPerksGoTags.length, allOptionsSelectedLabel: formatMessage({ id: "perks.categories.filterBy.perksGo.allOptionsSelected.label" }), multipleOptionsSelectedLabel: "perks.categories.filterBy.perksGo.multipleOptionsSelected.label", allOptionText: formatMessage({ id: "perks.categories.checkboxGroup.perksGo.allOptions.text" }), resetButtonText: formatMessage({ id: "perks.categories.checkboxGroup.reset.buttonText" }), saveButtonText: formatMessage({ id: "perks.categories.checkboxGroup.save.buttonText" }), onSelect: this.handleSelectPerksGoFilter, onSelectAll: this.handleSelectAllPerksGoFilters, onReset: this.handleResetPerksGoFilters, onFilter: this.handleApplyPerksGoFilters })),
                        showFilterTags(filterOptions) && (React.createElement(StyledFilterBy, { id: id("filter", this.props), loadFilterOptions: loadFilterOptions, filterOptions: filterOptions, savedFilterOptionsExist: !!selectedLocationTags.length, allOptionsSelectedLabel: formatMessage({ id: "perks.categories.filterBy.locations.allOptionsSelected.label" }), multipleOptionsSelectedLabel: "perks.categories.filterBy.locations.multipleOptionsSelected.label", allOptionText: formatMessage({ id: "perks.categories.checkboxGroup.locations.allOptions.text" }), resetButtonText: formatMessage({ id: "perks.categories.checkboxGroup.reset.buttonText" }), saveButtonText: formatMessage({ id: "perks.categories.checkboxGroup.save.buttonText" }), onSelect: this.handleSelectFilter, onSelectAll: this.handleSelectAllFilters, onReset: this.handleResetFilters, onFilter: this.handleApplyFilters })),
                        React.createElement(StyledSortBy, { icon: IconTypes.filterUpAndDown, options: SORT_OPTIONS, value: variables.sort, onClick: this.handleSort })),
                    React.createElement(BadCategoryOrTag, { category: selectedCategory, tags: selectedTags },
                        React.createElement(DealListComponent, { variables: variables }, function (apollo) {
                            var _a = getDealList(apollo), results = _a.results, count = _a.count;
                            return (React.createElement(React.Fragment, null,
                                React.createElement(DisplayCount, { small: true, marginBottom: 1 },
                                    React.createElement(FormattedMessage, { id: "perks.categories.search.summary", values: { count: count, results: results === null || results === void 0 ? void 0 : results.length } })),
                                React.createElement(DealList, { deals: results || [], page: DEAL_PAGES.CATEGORY }),
                                React.createElement(ShowMoreOrThatsAll, { onNewPage: _this.handleNewPage, apollo: apollo })));
                        }))))));
    };
    Deals.defaultProps = {
        id: "deals"
    };
    Deals.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return Deals;
}(PureComponent));
export default injectIntl(Deals, { withRef: true });
